import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssetHistoryService from "../../Controller/AssetHistoryController";
import CreateAssetHistory from "./CreateAssetHistory";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
function AssetHistoryPage(AssetID) {
    AssetID = localStorage.getItem('AssetID');
    const navigate = useNavigate();
    const tableRef = useRef();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const [AssetHistoryList, setAssetHistory] = useState([]);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentAssetHistory, setCurrentAssetHistory] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [loading, setLoading] = useState(true);
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            "paging": true,
            "searching": true,
            "info": true,
            order: [[0, 'desc']],
        });
    };
    useEffect(() => {
        if (AssetHistoryList.length > 0) {
            initDataTable();
        }
    }, [AssetHistoryList]);


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const fetchAssetHistory = async () => {
        try {
            $(tableRef.current).DataTable().destroy();
            setLoading(true);
            const data = await AssetHistoryService.GetAllAssetHistory(redirectCallback, AssetID);
            setAssetHistory(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
        finally {
            setLoading(false); // Stop loading after fetching
        }
    };


    useEffect(() => {
        if (AssetID === 0) {

        } else {
            fetchAssetHistory();
        }
    }, [AssetID]);
    const handleCreateAssetHistoryClick = () => {
        setCurrentAssetHistory(null);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (history) => {
        setCurrentAssetHistory(history);
        setIsModalOpen(true);
    };
    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await AssetHistoryService.DeleteAssetHistory(redirectCallback, ID);
                    $(tableRef.current).DataTable().destroy();
                    fetchAssetHistory();
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };




    const handleSuccess = () => {
        fetchAssetHistory(); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateAssetHistoryClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px", marginTop: "10px" }}>
                <div className="col-sm-12">
                    <table className="table m-0 table-hover" ref={tableRef}>
                        <thead>
                            <tr>
                                <th>Created</th>
                                <th>Description</th>
                                <th>Action By</th>

                                <th className="rightColumn" style={{ "textAlign": "right" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {AssetHistoryList.map((history) => (

                                <tr key={history.PK_AssetHistory} onClick={localStorage.getItem('LicenseExpired') == "0" ? () => handleEditClick(history) : undefined} style={{ cursor: 'pointer' }}>
                                    <td>{formatDate(history.dt_Created)}</td>
                                    <td>{history.vc_Description}</td>
                                    <td>{history.DisplayName}</td>
                                    <td className={`rightColumn ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ "textAlign": "right" }}>

                                        <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={(event) => handleDeleteClick(event, history.PK_AssetHistory)}>
                                            <i className="icofont-ui-delete" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {isModalOpen && (
                <CreateAssetHistory
                    modalInstance={modalInstance}
                    currentAssetHistory={currentAssetHistory}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    AssetID={AssetID}
                />
            )}
        </div>
    );
}

export default AssetHistoryPage;
